module.exports = __webpack_public_path__ + "static/media/pangolist.92d083f2.png";